"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "TechFlow",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_techflow.png"
}, {
  name: "BuildGrid",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_buildgrid.png"
}, {
  name: "Agencify",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_agencify.png"
}, {
  name: "ScalePoint",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_scalepoint.png"
}, {
  name: "DevLogic",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_devlogic.png"
}, {
  name: "CloudBase",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_cloudbase.png"
}, {
  name: "SaaSLink",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_saaslink.png"
}, {
  name: "InnoHub",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/partner_innohub.png"
}];
export default function OurVenuePartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222480" id="trusted-by-builders" className="bg-background text-foreground overflow-hidden border-y border-border/10">
      <div ref={ref} className={`flex flex-col md:flex-row min-h-[400px] transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        {}
        <div className="md:w-32 lg:w-40 flex-shrink-0 flex items-center justify-center border-b md:border-b-0 md:border-r border-border/10 py-12 md:py-0 relative bg-primary/5">
          <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold tracking-widest text-muted-foreground/10 uppercase md:-rotate-90 whitespace-nowrap select-none">
            Agencies
          </h2>
        </div>

        {}
        <div className="flex-1 p-8 md:p-16 lg:p-24 flex items-center bg-background">
          <div className="flex flex-wrap justify-center md:justify-start items-center gap-12 md:gap-16 lg:gap-20 w-full max-w-6xl mx-auto">
            {partners.map((partner, i) => <div key={i} data-index={i} className="group relative flex items-center justify-center p-4 cursor-pointer">
                {}
                <div className="absolute inset-0 bg-primary/10 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
                {}
                <img src={partner.logo} alt={partner.name} className="h-10 md:h-12 lg:h-14 w-auto object-contain grayscale opacity-50 transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 relative z-10" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}